/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Grow } from '@mui/material';
import { LoadingActions } from 'modules/Dashboard/Cards/Actions/LoadingActions';
import React, { useEffect } from 'react';
import { useQuery } from 'services';
import ActionCard from 'shared/components/Cards/ActionCard';
import { ProcessModel } from 'types/models';
import { Paginated } from 'types/services';
import lang from 'utils/lang';
import { HeaderActions } from '../../HeaderActions';

export function ApproveProcessDiscountAction() {
  const [getProcessToApprove, , discountLoading] = useQuery<number[]>(
    '/discount-order',
    {
      isManager: 1
    }
  );

  const [getActionProcess, refetchActions, actionsLoading] = useQuery<
    Paginated<ProcessModel>
  >('/process', {
    'id[$in]': (getProcessToApprove || []).slice(0, 4),
    fetchOnInitialize: false
  });

  useEffect(() => {
    if (getProcessToApprove) {
      if (getProcessToApprove.length > 0) {
        refetchActions();
      }
    }
  }, [getProcessToApprove]);

  const actionsProcess = getActionProcess?.data || ([] as ProcessModel[]);

  const redirect = (id?: number) => {
    if (id) return `processo/${id}/aprovar-desconto`;
    return 'dashboard';
  };

  const loading = actionsLoading || discountLoading;

  return (
    <Grid item container direction="column" spacing={2}>
      {(getProcessToApprove?.length || 0) !== 0 && (
        <HeaderActions quantity={getProcessToApprove?.length || 0} />
      )}
      <Grid item container spacing={2} direction={{ xs: 'column', md: 'row' }}>
        {loading ? (
          <>
            {Array.from(new Array(4)).map(() => (
              <Grid item>
                <LoadingActions />
              </Grid>
            ))}
          </>
        ) : (
          <>
            {actionsProcess.map((actionProcess, key) => (
              <Grow in={!loading} timeout={key * 1000}>
                <Grid item md={3}>
                  <ActionCard
                    title="Gerente"
                    redirect={redirect(actionProcess?.id)}
                    action="Aprovar desconto no sistema "
                    chips={[
                      {
                        color:
                          actionProcess?.segment === 'public'
                            ? 'blue'
                            : 'green',
                        title: lang.segments[actionProcess?.segment || '']
                      }
                    ]}
                    city={actionProcess?.city}
                    tradingCode={actionProcess?.tradingCode || '-'}
                    createdAt={String(actionProcess?.createdAt)}
                  />
                </Grid>
              </Grow>
            ))}
          </>
        )}
      </Grid>
    </Grid>
  );
}
